// @flow
import React from "react"
import KeyboardedInput from "react-touch-screen-keyboard"

import CustomField from "./CustomField"
import styled from "styled-components"
import { BlockError } from "./Error"

import "./Keyboard.css"

class CustomKeyboardInput extends React.Component<any> {
  render() {
    return (
      <KeyboardedInput
        enabled
        type={this.props.type}
        onChange={this.props.onChange}
        value={this.props.value}
        min={this.props.min}
        max={this.props.max}
        step={this.props.step}
        name={this.props.name}
        className={this.props.className}
        placeholder={this.props.placeholder}
        defaultKeyboard="us"
        readOnly={this.props.readOnly} // optional
        opacity={0.9} // optional
      />
    )
  }
}

const StyledInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  line-height: 1.25em;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: ${props => props.theme.borderRadius};

  &:disabled {
    opacity: 0.7;
  }

  height: 72px;
  margin: 10px auto;
  font-size: 32px;
  color: #595959;
  font-family: "din-condensed";
  font-weight: 300;
  text-align: center;
`

const StyledKeyboardInput = StyledInput.withComponent(CustomKeyboardInput)

const ContactField = CustomField(StyledInput, BlockError)
const ContactKeyboardField = CustomField(StyledKeyboardInput, BlockError)

export { ContactField, ContactKeyboardField }



// WEBPACK FOOTER //
// ./src/UI/Form/ContactField.js